import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import PropTypes from "prop-types"; // ES6

const ImageLazyLoading = ({ src, alt, height, width, style }) => {
  return (
    <LazyLoadImage
      alt={alt}
      height={height}
      src={src}
      width={width}
      effect="blur"
      style={style && style}
    />
  );
};

ImageLazyLoading.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  style: PropTypes.object,
};

export default ImageLazyLoading;
